import { instantsInterceptor, } from '@/api/index';
import axios from "axios";
import { setInterceptors } from "@/api/common/interceptor";

function documentList(form) {
    return instantsInterceptor.post('/service/document/list', form);
}

function historyList(form) {
    return instantsInterceptor.post('/service/document/historylist', form);
}

function docTypeList(lang) {
    return instantsInterceptor.get('/mgmt/doctype/docTypeList?lang=' + lang);
}

function updateDocTypeOrder(form) {
    return instantsInterceptor.put('/mgmt/document/docTypeOrder', form);
}

function updateDocType(form) {
    return instantsInterceptor.post('/mgmt/doctype/update', form);
}

function getDocType(doctypeId) {
    return instantsInterceptor.get('/service/document/docType/' + doctypeId);
}

function uploadDocTypeImg(form) {
    return instantsInterceptor.post('/mgmt/doctype/img/' + form.get('doctypeId'), form);
}

function deleteDocType(form) {
    return instantsInterceptor.post('/mgmt/document/deleteDocType', form);
}

function fetchLanguages() {
    return instantsInterceptor.get('/service/code/languages');
}

function fetchDoctypeForm() {
    return instantsInterceptor.get('/mgmt/doctype/form');
}

function addDocType(form) {
    return instantsInterceptor.post('/mgmt/doctype/form', form);
}

function getDocTypeAndLabel(doctypeId) {
    return instantsInterceptor.get('/mgmt/doctype/updateForm/' + doctypeId);
}

function getLanguages() {
    return instantsInterceptor.get('/service/code/languages');
}

function changeDoctypeUse(form) {
    return instantsInterceptor.post('/mgmt/doctype/changeUse', form);
}

function downExcel() {
    let axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        responseType: 'blob',
    });

    let instance = setInterceptors(axiosInstance);

    return instance.get('/mgmt/doctype/excel');
}

function getFirstDoctypeList() {
    return instantsInterceptor.get('/mgmt/statistics/doctype/getFirstDoctypeList');
}

function getChartData(year, firstDoctype) {
    return instantsInterceptor.get('/mgmt/statistics/doctype/result?' + "year=" + year + "&firstDoctype=" + firstDoctype);
}

function checkDocTypeNameDuplication(form) {
    return instantsInterceptor.post('/mgmt/doctype/check', form);
}

export {
    documentList,
    historyList,
    docTypeList,
    updateDocTypeOrder,
    addDocType,
    updateDocType,
    getDocType,
    uploadDocTypeImg,
    deleteDocType,
    fetchLanguages,
    fetchDoctypeForm,
    getDocTypeAndLabel,
    getLanguages,
    downExcel,
    getFirstDoctypeList,
    getChartData,
    changeDoctypeUse,
    checkDocTypeNameDuplication
};